import './styles/Profile.scss';

import { useApolloClient } from '@apollo/client';

import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import USER_QUERY from 'gql/queries/currentUser.gql';

import { translations } from 'locales/i18n';
import usePageHeading from 'utils/hooks/usePageHeading';

import ProfilePage from './components/ProfilePage';

export function Profile(): ReactElement {
  const { t } = useTranslation();
  const client = useApolloClient();
  const userData = client.readQuery({ query: USER_QUERY });

  const user = userData.currentUser;
  usePageHeading(t(translations.layout.menu.profile()));

  return <ProfilePage user={user} />;
}
